import { Box, styled } from '@mui/material'
import type { BoxProps } from '@mui/material/Box'

interface IconBoxProps extends BoxProps {
  readonly backgroundColor?: string
  readonly size?: number
}

export const StyledIconBox = styled(Box)<IconBoxProps>(({ backgroundColor, size }) => ({
  width: size ?? 44,
  height: size ?? 44,
  borderRadius: 7,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: backgroundColor || '#1F0E72',
}))
